import { CommonSelect } from '../../../../components/select';

interface IProps {
  readonly selectedVersions: string[];
  readonly onVersionsChange: (versions: string[]) => void;
  readonly className?: string;
  readonly placeholderText?: string;
}

export const VersionSelect = (props: IProps) => {
  const handleVersionChange = (value: string[]) => {
    props.onVersionsChange(value);
  };

  const handleVersionCreate = () => {
    try {
      const trimmedVersions = props.selectedVersions
        .map((selectedVersions) => selectedVersions.trim())
        .filter(Boolean);
      if (trimmedVersions.length > 0) {
        props.onVersionsChange(trimmedVersions);
      }
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  return (
    <div>
      <CommonSelect
        mode="tags"
        // value={versions}
        className={props.className}
        value={props.selectedVersions}
        onChange={handleVersionChange}
        placeholder={props.placeholderText}
        onInputKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleVersionCreate();
          }
        }}
        open={false}
        options={props.selectedVersions?.map((ver) => {
          return {
            label: ver,
            value: ver,
          };
        })}
      ></CommonSelect>
    </div>
  );
};
